import { render, staticRenderFns } from "./SYCodeDetail.vue?vue&type=template&id=b1d88f0e&"
import script from "./SYCodeDetail.vue?vue&type=script&lang=js&"
export * from "./SYCodeDetail.vue?vue&type=script&lang=js&"
import style0 from "./SYCodeDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports